// @generated by protoc-gen-es v2.0.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/social/v2/service.proto (package creativefabrica.social.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { PaginationRequest, PaginationRequestJson, PaginationResponse, PaginationResponseJson } from "../../common/v1/types_pb";
import { file_creativefabrica_common_v1_types } from "../../common/v1/types_pb";
import type { ImageLibraryItem, ImageLibraryItemJson, Project, ProjectJson, SkillLevel, SkillLevelJson } from "./types_pb";
import { file_creativefabrica_social_v2_types } from "./types_pb";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/social/v2/service.proto.
 */
export const file_creativefabrica_social_v2_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_common_v1_types, file_creativefabrica_social_v2_types, file_google_api_annotations]);

/**
 * @generated from message creativefabrica.social.v2.OnVideoUploadCompletedRequest
 */
export type OnVideoUploadCompletedRequest = Message<"creativefabrica.social.v2.OnVideoUploadCompletedRequest"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: string object_key = 3;
   */
  objectKey: string;

  /**
   * @generated from field: repeated string hls_urls = 4;
   */
  hlsUrls: string[];

  /**
   * @generated from field: repeated string mp4_urls = 5;
   */
  mp4Urls: string[];

  /**
   * @generated from field: repeated string dash_urls = 6;
   */
  dashUrls: string[];

  /**
   * @generated from field: repeated string thumbnail_urls = 7;
   */
  thumbnailUrls: string[];

  /**
   * @generated from field: int64 size = 8;
   */
  size: bigint;

  /**
   * @generated from field: int64 duration = 9;
   */
  duration: bigint;

  /**
   * @generated from field: string user_id = 10;
   */
  userId: string;
};

/**
 * JSON type for the message creativefabrica.social.v2.OnVideoUploadCompletedRequest.
 */
export type OnVideoUploadCompletedRequestJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;

  /**
   * @generated from field: string object_key = 3;
   */
  objectKey?: string;

  /**
   * @generated from field: repeated string hls_urls = 4;
   */
  hlsUrls?: string[];

  /**
   * @generated from field: repeated string mp4_urls = 5;
   */
  mp4Urls?: string[];

  /**
   * @generated from field: repeated string dash_urls = 6;
   */
  dashUrls?: string[];

  /**
   * @generated from field: repeated string thumbnail_urls = 7;
   */
  thumbnailUrls?: string[];

  /**
   * @generated from field: int64 size = 8;
   */
  size?: string;

  /**
   * @generated from field: int64 duration = 9;
   */
  duration?: string;

  /**
   * @generated from field: string user_id = 10;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.social.v2.OnVideoUploadCompletedRequest.
 * Use `create(OnVideoUploadCompletedRequestSchema)` to create a new message.
 */
export const OnVideoUploadCompletedRequestSchema: GenMessage<OnVideoUploadCompletedRequest, OnVideoUploadCompletedRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 0);

/**
 * @generated from message creativefabrica.social.v2.OnVideoUploadCompletedResponse
 */
export type OnVideoUploadCompletedResponse = Message<"creativefabrica.social.v2.OnVideoUploadCompletedResponse"> & {
};

/**
 * JSON type for the message creativefabrica.social.v2.OnVideoUploadCompletedResponse.
 */
export type OnVideoUploadCompletedResponseJson = {
};

/**
 * Describes the message creativefabrica.social.v2.OnVideoUploadCompletedResponse.
 * Use `create(OnVideoUploadCompletedResponseSchema)` to create a new message.
 */
export const OnVideoUploadCompletedResponseSchema: GenMessage<OnVideoUploadCompletedResponse, OnVideoUploadCompletedResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 1);

/**
 * @generated from message creativefabrica.social.v2.OnUploadCompletedRequest
 */
export type OnUploadCompletedRequest = Message<"creativefabrica.social.v2.OnUploadCompletedRequest"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: creativefabrica.social.v2.UploadStatus status = 3;
   */
  status: UploadStatus;

  /**
   * @generated from field: bool is_image_library_upload = 4;
   */
  isImageLibraryUpload: boolean;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;
};

/**
 * JSON type for the message creativefabrica.social.v2.OnUploadCompletedRequest.
 */
export type OnUploadCompletedRequestJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;

  /**
   * @generated from field: creativefabrica.social.v2.UploadStatus status = 3;
   */
  status?: UploadStatusJson;

  /**
   * @generated from field: bool is_image_library_upload = 4;
   */
  isImageLibraryUpload?: boolean;

  /**
   * @generated from field: string user_id = 5;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.social.v2.OnUploadCompletedRequest.
 * Use `create(OnUploadCompletedRequestSchema)` to create a new message.
 */
export const OnUploadCompletedRequestSchema: GenMessage<OnUploadCompletedRequest, OnUploadCompletedRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 2);

/**
 * @generated from message creativefabrica.social.v2.OnUploadCompletedResponse
 */
export type OnUploadCompletedResponse = Message<"creativefabrica.social.v2.OnUploadCompletedResponse"> & {
};

/**
 * JSON type for the message creativefabrica.social.v2.OnUploadCompletedResponse.
 */
export type OnUploadCompletedResponseJson = {
};

/**
 * Describes the message creativefabrica.social.v2.OnUploadCompletedResponse.
 * Use `create(OnUploadCompletedResponseSchema)` to create a new message.
 */
export const OnUploadCompletedResponseSchema: GenMessage<OnUploadCompletedResponse, OnUploadCompletedResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 3);

/**
 * @generated from message creativefabrica.social.v2.OnProjectUpdatedRequest
 */
export type OnProjectUpdatedRequest = Message<"creativefabrica.social.v2.OnProjectUpdatedRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: bool origin_v2 = 2;
   */
  originV2: boolean;
};

/**
 * JSON type for the message creativefabrica.social.v2.OnProjectUpdatedRequest.
 */
export type OnProjectUpdatedRequestJson = {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId?: string;

  /**
   * @generated from field: bool origin_v2 = 2;
   */
  originV2?: boolean;
};

/**
 * Describes the message creativefabrica.social.v2.OnProjectUpdatedRequest.
 * Use `create(OnProjectUpdatedRequestSchema)` to create a new message.
 */
export const OnProjectUpdatedRequestSchema: GenMessage<OnProjectUpdatedRequest, OnProjectUpdatedRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 4);

/**
 * @generated from message creativefabrica.social.v2.OnProjectUpdatedResponse
 */
export type OnProjectUpdatedResponse = Message<"creativefabrica.social.v2.OnProjectUpdatedResponse"> & {
};

/**
 * JSON type for the message creativefabrica.social.v2.OnProjectUpdatedResponse.
 */
export type OnProjectUpdatedResponseJson = {
};

/**
 * Describes the message creativefabrica.social.v2.OnProjectUpdatedResponse.
 * Use `create(OnProjectUpdatedResponseSchema)` to create a new message.
 */
export const OnProjectUpdatedResponseSchema: GenMessage<OnProjectUpdatedResponse, OnProjectUpdatedResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 5);

/**
 * @generated from message creativefabrica.social.v2.ListMachinesRequest
 */
export type ListMachinesRequest = Message<"creativefabrica.social.v2.ListMachinesRequest"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;
};

/**
 * JSON type for the message creativefabrica.social.v2.ListMachinesRequest.
 */
export type ListMachinesRequestJson = {
  /**
   * @generated from field: string text = 1;
   */
  text?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.social.v2.ListMachinesRequest.
 * Use `create(ListMachinesRequestSchema)` to create a new message.
 */
export const ListMachinesRequestSchema: GenMessage<ListMachinesRequest, ListMachinesRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 6);

/**
 * @generated from message creativefabrica.social.v2.ListMachinesResponse
 */
export type ListMachinesResponse = Message<"creativefabrica.social.v2.ListMachinesResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated creativefabrica.social.v2.DropdownData data = 2;
   */
  data: DropdownData[];
};

/**
 * JSON type for the message creativefabrica.social.v2.ListMachinesResponse.
 */
export type ListMachinesResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.social.v2.DropdownData data = 2;
   */
  data?: DropdownDataJson[];
};

/**
 * Describes the message creativefabrica.social.v2.ListMachinesResponse.
 * Use `create(ListMachinesResponseSchema)` to create a new message.
 */
export const ListMachinesResponseSchema: GenMessage<ListMachinesResponse, ListMachinesResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 7);

/**
 * @generated from message creativefabrica.social.v2.ListMaterialsRequest
 */
export type ListMaterialsRequest = Message<"creativefabrica.social.v2.ListMaterialsRequest"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;
};

/**
 * JSON type for the message creativefabrica.social.v2.ListMaterialsRequest.
 */
export type ListMaterialsRequestJson = {
  /**
   * @generated from field: string text = 1;
   */
  text?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.social.v2.ListMaterialsRequest.
 * Use `create(ListMaterialsRequestSchema)` to create a new message.
 */
export const ListMaterialsRequestSchema: GenMessage<ListMaterialsRequest, ListMaterialsRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 8);

/**
 * @generated from message creativefabrica.social.v2.ListMaterialsResponse
 */
export type ListMaterialsResponse = Message<"creativefabrica.social.v2.ListMaterialsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated creativefabrica.social.v2.DropdownData data = 2;
   */
  data: DropdownData[];
};

/**
 * JSON type for the message creativefabrica.social.v2.ListMaterialsResponse.
 */
export type ListMaterialsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.social.v2.DropdownData data = 2;
   */
  data?: DropdownDataJson[];
};

/**
 * Describes the message creativefabrica.social.v2.ListMaterialsResponse.
 * Use `create(ListMaterialsResponseSchema)` to create a new message.
 */
export const ListMaterialsResponseSchema: GenMessage<ListMaterialsResponse, ListMaterialsResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 9);

/**
 * @generated from message creativefabrica.social.v2.ListThemesRequest
 */
export type ListThemesRequest = Message<"creativefabrica.social.v2.ListThemesRequest"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;
};

/**
 * JSON type for the message creativefabrica.social.v2.ListThemesRequest.
 */
export type ListThemesRequestJson = {
  /**
   * @generated from field: string text = 1;
   */
  text?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.social.v2.ListThemesRequest.
 * Use `create(ListThemesRequestSchema)` to create a new message.
 */
export const ListThemesRequestSchema: GenMessage<ListThemesRequest, ListThemesRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 10);

/**
 * @generated from message creativefabrica.social.v2.ListThemesResponse
 */
export type ListThemesResponse = Message<"creativefabrica.social.v2.ListThemesResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated creativefabrica.social.v2.DropdownData data = 2;
   */
  data: DropdownData[];
};

/**
 * JSON type for the message creativefabrica.social.v2.ListThemesResponse.
 */
export type ListThemesResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.social.v2.DropdownData data = 2;
   */
  data?: DropdownDataJson[];
};

/**
 * Describes the message creativefabrica.social.v2.ListThemesResponse.
 * Use `create(ListThemesResponseSchema)` to create a new message.
 */
export const ListThemesResponseSchema: GenMessage<ListThemesResponse, ListThemesResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 11);

/**
 * @generated from message creativefabrica.social.v2.ListAssetsRequest
 */
export type ListAssetsRequest = Message<"creativefabrica.social.v2.ListAssetsRequest"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;
};

/**
 * JSON type for the message creativefabrica.social.v2.ListAssetsRequest.
 */
export type ListAssetsRequestJson = {
  /**
   * @generated from field: string text = 1;
   */
  text?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.social.v2.ListAssetsRequest.
 * Use `create(ListAssetsRequestSchema)` to create a new message.
 */
export const ListAssetsRequestSchema: GenMessage<ListAssetsRequest, ListAssetsRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 12);

/**
 * @generated from message creativefabrica.social.v2.ListAssetsResponse
 */
export type ListAssetsResponse = Message<"creativefabrica.social.v2.ListAssetsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated creativefabrica.social.v2.DropdownData data = 2;
   */
  data: DropdownData[];
};

/**
 * JSON type for the message creativefabrica.social.v2.ListAssetsResponse.
 */
export type ListAssetsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.social.v2.DropdownData data = 2;
   */
  data?: DropdownDataJson[];
};

/**
 * Describes the message creativefabrica.social.v2.ListAssetsResponse.
 * Use `create(ListAssetsResponseSchema)` to create a new message.
 */
export const ListAssetsResponseSchema: GenMessage<ListAssetsResponse, ListAssetsResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 13);

/**
 * @generated from message creativefabrica.social.v2.DropdownData
 */
export type DropdownData = Message<"creativefabrica.social.v2.DropdownData"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string thumbnail_url = 3;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;
};

/**
 * JSON type for the message creativefabrica.social.v2.DropdownData.
 */
export type DropdownDataJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string thumbnail_url = 3;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: string category = 4;
   */
  category?: string;
};

/**
 * Describes the message creativefabrica.social.v2.DropdownData.
 * Use `create(DropdownDataSchema)` to create a new message.
 */
export const DropdownDataSchema: GenMessage<DropdownData, DropdownDataJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 14);

/**
 * @generated from message creativefabrica.social.v2.CreateSignedUrlRequest
 */
export type CreateSignedUrlRequest = Message<"creativefabrica.social.v2.CreateSignedUrlRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;

  /**
   * @generated from field: bool is_image_library_upload = 3;
   */
  isImageLibraryUpload: boolean;
};

/**
 * JSON type for the message creativefabrica.social.v2.CreateSignedUrlRequest.
 */
export type CreateSignedUrlRequestJson = {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize?: string;

  /**
   * @generated from field: bool is_image_library_upload = 3;
   */
  isImageLibraryUpload?: boolean;
};

/**
 * Describes the message creativefabrica.social.v2.CreateSignedUrlRequest.
 * Use `create(CreateSignedUrlRequestSchema)` to create a new message.
 */
export const CreateSignedUrlRequestSchema: GenMessage<CreateSignedUrlRequest, CreateSignedUrlRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 15);

/**
 * @generated from message creativefabrica.social.v2.CreateSignedUrlResponse
 */
export type CreateSignedUrlResponse = Message<"creativefabrica.social.v2.CreateSignedUrlResponse"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: map<string, string> form_fields = 3;
   */
  formFields: { [key: string]: string };
};

/**
 * JSON type for the message creativefabrica.social.v2.CreateSignedUrlResponse.
 */
export type CreateSignedUrlResponseJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;

  /**
   * @generated from field: map<string, string> form_fields = 3;
   */
  formFields?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.social.v2.CreateSignedUrlResponse.
 * Use `create(CreateSignedUrlResponseSchema)` to create a new message.
 */
export const CreateSignedUrlResponseSchema: GenMessage<CreateSignedUrlResponse, CreateSignedUrlResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 16);

/**
 * @generated from message creativefabrica.social.v2.PostProductProjectRequest
 */
export type PostProductProjectRequest = Message<"creativefabrica.social.v2.PostProductProjectRequest"> & {
  /**
   * @generated from field: string product_id = 1;
   */
  productId: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated string upload_ids = 3;
   */
  uploadIds: string[];

  /**
   * @generated from field: repeated string video_ids = 10;
   */
  videoIds: string[];

  /**
   * @generated from field: repeated string asset_ids = 4;
   */
  assetIds: string[];

  /**
   * @generated from field: creativefabrica.social.v2.SkillLevel skill_level = 5;
   */
  skillLevel: SkillLevel;

  /**
   * @generated from field: repeated int32 machine_ids = 6;
   */
  machineIds: number[];

  /**
   * @generated from field: repeated int32 material_ids = 7;
   */
  materialIds: number[];

  /**
   * @generated from field: repeated int32 theme_ids = 8;
   */
  themeIds: number[];

  /**
   * @generated from field: repeated creativefabrica.social.v2.CreateInstructionRequest instructions = 9;
   */
  instructions: CreateInstructionRequest[];
};

/**
 * JSON type for the message creativefabrica.social.v2.PostProductProjectRequest.
 */
export type PostProductProjectRequestJson = {
  /**
   * @generated from field: string product_id = 1;
   */
  productId?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: repeated string upload_ids = 3;
   */
  uploadIds?: string[];

  /**
   * @generated from field: repeated string video_ids = 10;
   */
  videoIds?: string[];

  /**
   * @generated from field: repeated string asset_ids = 4;
   */
  assetIds?: string[];

  /**
   * @generated from field: creativefabrica.social.v2.SkillLevel skill_level = 5;
   */
  skillLevel?: SkillLevelJson;

  /**
   * @generated from field: repeated int32 machine_ids = 6;
   */
  machineIds?: number[];

  /**
   * @generated from field: repeated int32 material_ids = 7;
   */
  materialIds?: number[];

  /**
   * @generated from field: repeated int32 theme_ids = 8;
   */
  themeIds?: number[];

  /**
   * @generated from field: repeated creativefabrica.social.v2.CreateInstructionRequest instructions = 9;
   */
  instructions?: CreateInstructionRequestJson[];
};

/**
 * Describes the message creativefabrica.social.v2.PostProductProjectRequest.
 * Use `create(PostProductProjectRequestSchema)` to create a new message.
 */
export const PostProductProjectRequestSchema: GenMessage<PostProductProjectRequest, PostProductProjectRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 17);

/**
 * @generated from message creativefabrica.social.v2.CreateInstructionRequest
 */
export type CreateInstructionRequest = Message<"creativefabrica.social.v2.CreateInstructionRequest"> & {
  /**
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * @generated from field: repeated string upload_ids = 2;
   */
  uploadIds: string[];

  /**
   * @generated from field: repeated string video_ids = 3;
   */
  videoIds: string[];
};

/**
 * JSON type for the message creativefabrica.social.v2.CreateInstructionRequest.
 */
export type CreateInstructionRequestJson = {
  /**
   * @generated from field: string description = 1;
   */
  description?: string;

  /**
   * @generated from field: repeated string upload_ids = 2;
   */
  uploadIds?: string[];

  /**
   * @generated from field: repeated string video_ids = 3;
   */
  videoIds?: string[];
};

/**
 * Describes the message creativefabrica.social.v2.CreateInstructionRequest.
 * Use `create(CreateInstructionRequestSchema)` to create a new message.
 */
export const CreateInstructionRequestSchema: GenMessage<CreateInstructionRequest, CreateInstructionRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 18);

/**
 * @generated from message creativefabrica.social.v2.PostProductProjectResponse
 */
export type PostProductProjectResponse = Message<"creativefabrica.social.v2.PostProductProjectResponse"> & {
  /**
   * @generated from field: creativefabrica.social.v2.Project project = 1;
   */
  project?: Project;
};

/**
 * JSON type for the message creativefabrica.social.v2.PostProductProjectResponse.
 */
export type PostProductProjectResponseJson = {
  /**
   * @generated from field: creativefabrica.social.v2.Project project = 1;
   */
  project?: ProjectJson;
};

/**
 * Describes the message creativefabrica.social.v2.PostProductProjectResponse.
 * Use `create(PostProductProjectResponseSchema)` to create a new message.
 */
export const PostProductProjectResponseSchema: GenMessage<PostProductProjectResponse, PostProductProjectResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 19);

/**
 * @generated from message creativefabrica.social.v2.ListImageLibraryRequest
 */
export type ListImageLibraryRequest = Message<"creativefabrica.social.v2.ListImageLibraryRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * JSON type for the message creativefabrica.social.v2.ListImageLibraryRequest.
 */
export type ListImageLibraryRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.social.v2.ListImageLibraryRequest.
 * Use `create(ListImageLibraryRequestSchema)` to create a new message.
 */
export const ListImageLibraryRequestSchema: GenMessage<ListImageLibraryRequest, ListImageLibraryRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 20);

/**
 * @generated from message creativefabrica.social.v2.ListImageLibraryResponse
 */
export type ListImageLibraryResponse = Message<"creativefabrica.social.v2.ListImageLibraryResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse response = 1;
   */
  response?: PaginationResponse;

  /**
   * @generated from field: repeated creativefabrica.social.v2.ImageLibraryItem images = 2;
   */
  images: ImageLibraryItem[];
};

/**
 * JSON type for the message creativefabrica.social.v2.ListImageLibraryResponse.
 */
export type ListImageLibraryResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse response = 1;
   */
  response?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.social.v2.ImageLibraryItem images = 2;
   */
  images?: ImageLibraryItemJson[];
};

/**
 * Describes the message creativefabrica.social.v2.ListImageLibraryResponse.
 * Use `create(ListImageLibraryResponseSchema)` to create a new message.
 */
export const ListImageLibraryResponseSchema: GenMessage<ListImageLibraryResponse, ListImageLibraryResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 21);

/**
 * @generated from message creativefabrica.social.v2.SelectFeaturedImagesRequest
 */
export type SelectFeaturedImagesRequest = Message<"creativefabrica.social.v2.SelectFeaturedImagesRequest"> & {
  /**
   * @generated from field: repeated creativefabrica.social.v2.SelectFeaturedImagesRequest.ImageSelection images = 1;
   */
  images: SelectFeaturedImagesRequest_ImageSelection[];
};

/**
 * JSON type for the message creativefabrica.social.v2.SelectFeaturedImagesRequest.
 */
export type SelectFeaturedImagesRequestJson = {
  /**
   * @generated from field: repeated creativefabrica.social.v2.SelectFeaturedImagesRequest.ImageSelection images = 1;
   */
  images?: SelectFeaturedImagesRequest_ImageSelectionJson[];
};

/**
 * Describes the message creativefabrica.social.v2.SelectFeaturedImagesRequest.
 * Use `create(SelectFeaturedImagesRequestSchema)` to create a new message.
 */
export const SelectFeaturedImagesRequestSchema: GenMessage<SelectFeaturedImagesRequest, SelectFeaturedImagesRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 22);

/**
 * @generated from message creativefabrica.social.v2.SelectFeaturedImagesRequest.ImageSelection
 */
export type SelectFeaturedImagesRequest_ImageSelection = Message<"creativefabrica.social.v2.SelectFeaturedImagesRequest.ImageSelection"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: int32 order = 2;
   */
  order: number;
};

/**
 * JSON type for the message creativefabrica.social.v2.SelectFeaturedImagesRequest.ImageSelection.
 */
export type SelectFeaturedImagesRequest_ImageSelectionJson = {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId?: string;

  /**
   * @generated from field: int32 order = 2;
   */
  order?: number;
};

/**
 * Describes the message creativefabrica.social.v2.SelectFeaturedImagesRequest.ImageSelection.
 * Use `create(SelectFeaturedImagesRequest_ImageSelectionSchema)` to create a new message.
 */
export const SelectFeaturedImagesRequest_ImageSelectionSchema: GenMessage<SelectFeaturedImagesRequest_ImageSelection, SelectFeaturedImagesRequest_ImageSelectionJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 22, 0);

/**
 * @generated from message creativefabrica.social.v2.SelectFeaturedImagesResponse
 */
export type SelectFeaturedImagesResponse = Message<"creativefabrica.social.v2.SelectFeaturedImagesResponse"> & {
};

/**
 * JSON type for the message creativefabrica.social.v2.SelectFeaturedImagesResponse.
 */
export type SelectFeaturedImagesResponseJson = {
};

/**
 * Describes the message creativefabrica.social.v2.SelectFeaturedImagesResponse.
 * Use `create(SelectFeaturedImagesResponseSchema)` to create a new message.
 */
export const SelectFeaturedImagesResponseSchema: GenMessage<SelectFeaturedImagesResponse, SelectFeaturedImagesResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 23);

/**
 * @generated from message creativefabrica.social.v2.GetUserFeaturedImagesRequest
 */
export type GetUserFeaturedImagesRequest = Message<"creativefabrica.social.v2.GetUserFeaturedImagesRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string user_slug = 2;
   */
  userSlug: string;
};

/**
 * JSON type for the message creativefabrica.social.v2.GetUserFeaturedImagesRequest.
 */
export type GetUserFeaturedImagesRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string user_slug = 2;
   */
  userSlug?: string;
};

/**
 * Describes the message creativefabrica.social.v2.GetUserFeaturedImagesRequest.
 * Use `create(GetUserFeaturedImagesRequestSchema)` to create a new message.
 */
export const GetUserFeaturedImagesRequestSchema: GenMessage<GetUserFeaturedImagesRequest, GetUserFeaturedImagesRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 24);

/**
 * @generated from message creativefabrica.social.v2.GetUserFeaturedImagesResponse
 */
export type GetUserFeaturedImagesResponse = Message<"creativefabrica.social.v2.GetUserFeaturedImagesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.social.v2.ImageLibraryItem images = 1;
   */
  images: ImageLibraryItem[];
};

/**
 * JSON type for the message creativefabrica.social.v2.GetUserFeaturedImagesResponse.
 */
export type GetUserFeaturedImagesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.social.v2.ImageLibraryItem images = 1;
   */
  images?: ImageLibraryItemJson[];
};

/**
 * Describes the message creativefabrica.social.v2.GetUserFeaturedImagesResponse.
 * Use `create(GetUserFeaturedImagesResponseSchema)` to create a new message.
 */
export const GetUserFeaturedImagesResponseSchema: GenMessage<GetUserFeaturedImagesResponse, GetUserFeaturedImagesResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 25);

/**
 * @generated from message creativefabrica.social.v2.GetUserFeedStatsRequest
 */
export type GetUserFeedStatsRequest = Message<"creativefabrica.social.v2.GetUserFeedStatsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string user_slug = 2;
   */
  userSlug: string;
};

/**
 * JSON type for the message creativefabrica.social.v2.GetUserFeedStatsRequest.
 */
export type GetUserFeedStatsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string user_slug = 2;
   */
  userSlug?: string;
};

/**
 * Describes the message creativefabrica.social.v2.GetUserFeedStatsRequest.
 * Use `create(GetUserFeedStatsRequestSchema)` to create a new message.
 */
export const GetUserFeedStatsRequestSchema: GenMessage<GetUserFeedStatsRequest, GetUserFeedStatsRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 26);

/**
 * @generated from message creativefabrica.social.v2.GetUserFeedStatsResponse
 */
export type GetUserFeedStatsResponse = Message<"creativefabrica.social.v2.GetUserFeedStatsResponse"> & {
  /**
   * @generated from field: int32 posts_count = 1;
   */
  postsCount: number;
};

/**
 * JSON type for the message creativefabrica.social.v2.GetUserFeedStatsResponse.
 */
export type GetUserFeedStatsResponseJson = {
  /**
   * @generated from field: int32 posts_count = 1;
   */
  postsCount?: number;
};

/**
 * Describes the message creativefabrica.social.v2.GetUserFeedStatsResponse.
 * Use `create(GetUserFeedStatsResponseSchema)` to create a new message.
 */
export const GetUserFeedStatsResponseSchema: GenMessage<GetUserFeedStatsResponse, GetUserFeedStatsResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 27);

/**
 * @generated from message creativefabrica.social.v2.GetCuratedFeedRequest
 */
export type GetCuratedFeedRequest = Message<"creativefabrica.social.v2.GetCuratedFeedRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * JSON type for the message creativefabrica.social.v2.GetCuratedFeedRequest.
 */
export type GetCuratedFeedRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.social.v2.GetCuratedFeedRequest.
 * Use `create(GetCuratedFeedRequestSchema)` to create a new message.
 */
export const GetCuratedFeedRequestSchema: GenMessage<GetCuratedFeedRequest, GetCuratedFeedRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 28);

/**
 * @generated from message creativefabrica.social.v2.GetCuratedFeedResponse
 */
export type GetCuratedFeedResponse = Message<"creativefabrica.social.v2.GetCuratedFeedResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.social.v2.Project projects = 1;
   */
  projects: Project[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * JSON type for the message creativefabrica.social.v2.GetCuratedFeedResponse.
 */
export type GetCuratedFeedResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.social.v2.Project projects = 1;
   */
  projects?: ProjectJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.social.v2.GetCuratedFeedResponse.
 * Use `create(GetCuratedFeedResponseSchema)` to create a new message.
 */
export const GetCuratedFeedResponseSchema: GenMessage<GetCuratedFeedResponse, GetCuratedFeedResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_service, 29);

/**
 * @generated from enum creativefabrica.social.v2.UploadStatus
 */
export enum UploadStatus {
  /**
   * @generated from enum value: UPLOAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_STATUS_COMPLETED = 1;
   */
  COMPLETED = 1,

  /**
   * @generated from enum value: UPLOAD_STATUS_FAILED = 2;
   */
  FAILED = 2,
}

/**
 * JSON type for the enum creativefabrica.social.v2.UploadStatus.
 */
export type UploadStatusJson = "UPLOAD_STATUS_UNSPECIFIED" | "UPLOAD_STATUS_COMPLETED" | "UPLOAD_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.social.v2.UploadStatus.
 */
export const UploadStatusSchema: GenEnum<UploadStatus, UploadStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_social_v2_service, 0);

/**
 * @generated from service creativefabrica.social.v2.SocialService
 */
export const SocialService: GenService<{
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.PostProductProject
   */
  postProductProject: {
    methodKind: "unary";
    input: typeof PostProductProjectRequestSchema;
    output: typeof PostProductProjectResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.ListMachines
   */
  listMachines: {
    methodKind: "unary";
    input: typeof ListMachinesRequestSchema;
    output: typeof ListMachinesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.ListMaterials
   */
  listMaterials: {
    methodKind: "unary";
    input: typeof ListMaterialsRequestSchema;
    output: typeof ListMaterialsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.ListThemes
   */
  listThemes: {
    methodKind: "unary";
    input: typeof ListThemesRequestSchema;
    output: typeof ListThemesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.ListAssets
   */
  listAssets: {
    methodKind: "unary";
    input: typeof ListAssetsRequestSchema;
    output: typeof ListAssetsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.CreateSignedUrl
   */
  createSignedUrl: {
    methodKind: "unary";
    input: typeof CreateSignedUrlRequestSchema;
    output: typeof CreateSignedUrlResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.ListImageLibrary
   */
  listImageLibrary: {
    methodKind: "unary";
    input: typeof ListImageLibraryRequestSchema;
    output: typeof ListImageLibraryResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.SelectFeaturedImages
   */
  selectFeaturedImages: {
    methodKind: "unary";
    input: typeof SelectFeaturedImagesRequestSchema;
    output: typeof SelectFeaturedImagesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.GetUserFeaturedImages
   */
  getUserFeaturedImages: {
    methodKind: "unary";
    input: typeof GetUserFeaturedImagesRequestSchema;
    output: typeof GetUserFeaturedImagesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.GetUserFeedStats
   */
  getUserFeedStats: {
    methodKind: "unary";
    input: typeof GetUserFeedStatsRequestSchema;
    output: typeof GetUserFeedStatsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.SocialService.GetCuratedFeed
   */
  getCuratedFeed: {
    methodKind: "unary";
    input: typeof GetCuratedFeedRequestSchema;
    output: typeof GetCuratedFeedResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_social_v2_service, 0);

/**
 * @generated from service creativefabrica.social.v2.InternalSocialService
 */
export const InternalSocialService: GenService<{
  /**
   * @generated from rpc creativefabrica.social.v2.InternalSocialService.OnUploadCompleted
   */
  onUploadCompleted: {
    methodKind: "unary";
    input: typeof OnUploadCompletedRequestSchema;
    output: typeof OnUploadCompletedResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.InternalSocialService.OnVideoUploadCompleted
   */
  onVideoUploadCompleted: {
    methodKind: "unary";
    input: typeof OnVideoUploadCompletedRequestSchema;
    output: typeof OnVideoUploadCompletedResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.social.v2.InternalSocialService.OnProjectUpdated
   */
  onProjectUpdated: {
    methodKind: "unary";
    input: typeof OnProjectUpdatedRequestSchema;
    output: typeof OnProjectUpdatedResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_social_v2_service, 1);

